import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import '../../assets/fonts/NanumGothic.js';
import '../../assets/fonts/NanumGothicBold-bold.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-responsive';
import $ from 'jquery';
import { useAuth } from '../../contexts/AuthContext';
import * as CONST from '../../constants';

const ResultHeader = ({ onPdfExport, isGenerating, filters, isFarmOwner, managementValues, nationValues }) => {
    let tpiHeader = 'TPI';

    if (filters.country === '01') {
        tpiHeader = 'KTPI';
    } else if (filters.country === '03') {
        tpiHeader = 'LPI';
    } else if (filters.country === '02' || filters.country === '04') {
        tpiHeader = 'TPI';
    }

    return (
        <div className="card" style={{ marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.75rem', marginBottom: '1rem' }}>
                <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#374151', margin: 0 }}>
                    계획교배용 씨수소 선정표
                </h3>
                <button className="secondary-button" onClick={onPdfExport} disabled={isGenerating}>
                    {isGenerating ? 'PDF 생성 중...' : 'PDF 저장'}
                </button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem 1.5rem', fontSize: '0.875rem' }}>
                {!isFarmOwner && (
                    <div style={{ display: 'flex' }}>
                        <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>생산</span>
                        <span style={{ color: '#1f2937' }}>{filters.prodRatio}</span>
                    </div>
                )}
                {!isFarmOwner && (
                    <div style={{ display: 'flex' }}>
                        <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>체형</span>
                        <span style={{ color: '#1f2937' }}>{filters.confRatio}</span>
                    </div>
                )}
                <div style={{ display: 'flex' }}>
                    <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>성적기준일</span>
                    <span style={{ color: '#1f2937' }}>{filters.ocapaDate?.substring(0, 7)}</span>
                </div>
                <div style={{ display: 'flex' }}>
                    <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>임계근친계수</span>
                    <span style={{ color: '#1f2937' }}>{filters.inbreedingCoefficient}</span>
                </div>

                <div style={{ display: 'flex' }}>
                    <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>지수선택국가</span>
                    <span style={{ color: '#1f2937' }}>{nationValues}({tpiHeader})</span>
                </div>
                <div style={{ display: 'flex' }}>
                    <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>품종</span>
                    <span style={{ color: '#1f2937' }}>{filters.breed}</span>
                </div>
                <div style={{ display: 'flex' }}>
                    <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>유전인자</span>
                    <span style={{ color: '#1f2937' }}>{filters.gene}</span>
                </div>
                <div style={{ display: 'flex' }}>
                    <span style={{ fontWeight: '600', color: '#4b5563', width: '80px' }}>경영방향</span>
                    <span style={{ color: '#1f2937' }}>{managementValues}</span>
                </div>
            </div>
        </div>
    );
}

const ResultBottom = ({ supplierInfo }) => (
    <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.75rem', marginBottom: '1rem' }}>
            <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#374151', margin: 0 }}>
                공급업체 주소 및 연락처
            </h3>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '90px 1fr', gap: '0.5rem 1.5rem', fontSize: '0.875rem' }}>
            <span style={{ fontWeight: '600', color: '#4b5563', textAlign: 'right' }}>공급업체번호</span>
            <span style={{ fontWeight: '600', color: '#4b5563' }}>업체명</span>
            {supplierInfo && supplierInfo.length > 0 ? (
                supplierInfo.map((info, idx) => (
                    <>
                        <span key={`no-${idx}`} style={{ color: '#1f2937', textAlign: 'right' }}>{info.icmp_no || 'N/A'}</span>
                        <span key={`name-${idx}`} style={{ color: '#1f2937' }}>{info.icmp_cname || 'N/A'}</span>
                    </>
                ))
            ) : (
                <>
                    <span style={{ color: '#6b7280', textAlign: 'right' }}>-</span>
                    <span style={{ color: '#6b7280' }}>-</span>
                </>
            )}
        </div>
    </div>
);

const MatingPlanResult = ({ planState, selectedFarm, setDialog, filters }) => {
    const tableRef = useRef(null);
    const semenTableRef = useRef(null);
    const dtApi = useRef(null);
    const semenDtApi = useRef(null);
    const [matingResults, setMatingResults] = useState([]);
    const [semenInfoResults, setSemenInfoResults] = useState([]);
    const [supplierInfo, setSupplierInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const resultRef = useRef(null);
    const { user } = useAuth();
    const isFarmOwner = user?.mtype1 === CONST.USER_TYPE_FARM_OWNER;
    const [typeOptions, setTypeOptions] = useState([]);
    const [nationOptions, setNationOptions] = useState([]);

    // 코드 옵션 가져오기
    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await axios.get('/api/code');
                if (response.data?.typeOptions) {
                    setTypeOptions(response.data.typeOptions);
                }
                if (response.data?.nationOptions) {
                    setNationOptions(response.data.nationOptions);
                }
            } catch (error) {
                console.error("옵션 정보 조회 실패:", error);
            }
        };
        fetchOptions();
    }, []);

    // 경영방향 코드 -> 값 변환 함수
    const getManagementValues = useCallback(() => {
        if (!filters.management || filters.management.length === 0) return '전체';

        const values = filters.management.map(code => {
            const option = typeOptions.find(opt => opt.code === code);
            return option ? option.value : code;
        });
        return values.join(', ');
    }, [filters.management, typeOptions]);

    const getNationValues = useCallback(() => {
        if (!filters.country || filters.country.length === 0) return '전체';

        const value = nationOptions.find(opt => opt.code === filters.country);

        return value?.cname;
    }, [filters.country, nationOptions]);

    const handlePdfExport = async () => {

        let tpiHeader = 'TPI';

        if (filters.country === '01') {
            tpiHeader = 'KTPI';
        } else if (filters.country === '03') {
            tpiHeader = 'LPI';
        } else if (filters.country === '02' || filters.country === '04') {
            tpiHeader = 'TPI';
        }

        try {
            if (isGeneratingPdf) return;
            setIsGeneratingPdf(true);

            const pdf = new jsPDF({
                orientation: 'landscape', // 'l' for landscape
                unit: 'mm',
                format: 'a4'
            });

            pdf.setFont('NanumGothic');

            // 1. 헤더 정보 그리기 (ResultHeader 내용)
            pdf.setFontSize(16);
            const farmName = (selectedFarm?.name || '').trim();
            const pdfTitle = farmName ? `${farmName} 계획교배용 씨수소 선정표` : '계획교배용 씨수소 선정표';
            pdf.text(pdfTitle, 14, 15);

            pdf.setFontSize(9);
            pdf.setFontSize(9);

            const managementValues = getManagementValues();
            const nationValues = getNationValues();

            let headerData;
            if (isFarmOwner) {
                headerData = [
                    ['성적기준일', filters.ocapaDate?.substring(0, 7), '임계근친계수', filters.inbreedingCoefficient, '지수선택국가', nationValues + '(' + tpiHeader + ')'],
                    ['품종', filters.breed, '유전인자', filters.gene, '경영방향', managementValues]
                ];
            } else {
                headerData = [
                    ['생산', filters.prodRatio, '체형', filters.confRatio, '성적기준일', filters.ocapaDate?.substring(0, 7), '임계근친계수', filters.inbreedingCoefficient],
                    ['지수선택국가', nationValues, '품종', filters.breed, '유전인자', filters.gene, '경영방향', managementValues]
                ];
            }

            autoTable(pdf, {
                startY: 20,
                body: headerData,
                theme: 'plain',
                styles: { font: 'NanumGothic', fontSize: 9 },
                columnStyles: {
                    0: { fontStyle: 'bold' },
                    2: { fontStyle: 'bold' },
                    4: { fontStyle: 'bold' },
                    6: { fontStyle: 'bold' },
                }
            });

            // 2. 첫 번째 테이블 (계획교배 결과) 그리기
            const tableData = dtApi.current ? dtApi.current.rows({ search: 'applied' }).data().toArray() : matingResults;
            const criticalInbreeding = 12.5;

            autoTable(pdf, {
                head: [columns.map(c => c.title === '부X외조부 (한글)' ? '부X\n외조부' : c.title)],
                body: tableData.map(row => columns.map(c => {
                    // '지수' 컬럼인 경우 indices_X와 indices_X_1을 개행 문자로 합침 (PDF는 항상 상하 표시)
                    if (c.title === '지수' && c.data && c.data.startsWith('indices_')) {
                        const extraKey = c.data.replace('indices_', 'sub_idx_');
                        return `${row[c.data].trim() || ''}\n${row[extraKey].trim() || ''}`;
                    }
                    // '순위' 컬럼인 경우 place_X와 h_short_X를 개행 문자로 합침
                    if (c.title.includes('순위') && c.data && c.data.startsWith('place_')) {
                        const extraKey = c.data.replace('place_', 'h_short_');
                        return `${row[c.data].trim() || ''}\n${row[extraKey].trim() || ''}`;
                    }
                    return row[c.data];
                })),
                startY: pdf.lastAutoTable.finalY + 5,
                margin: { left: 14, right: 14 },
                theme: 'grid',
                styles: { font: 'NanumGothic', fontSize: 6.5, cellPadding: 1.2, lineColor: [0, 0, 0], lineWidth: 0.2 },
                columnStyles: {
                    2: { halign: 'right' }, // 등록번호
                    3: { halign: 'right' }, // 1순위
                    4: { halign: 'center' }, // 1순위 지수
                    5: { halign: 'right' }, // 1순위 근교
                    6: { halign: 'right' }, // 2순위
                    7: { halign: 'center' }, // 2순위 지수
                    8: { halign: 'right' }, // 2순위 근교
                    9: { halign: 'right' }, // 3순위
                    10: { halign: 'center' }, // 3순위 지수
                    11: { halign: 'right' }, // 3순위 근교
                    12: { halign: 'right' }, // 4순위
                    13: { halign: 'center' }, // 4순위 지수
                    14: { halign: 'right' }, // 4순위 근교
                    15: { halign: 'right' }, // 5순위
                    16: { halign: 'center' }, // 5순위 지수
                    17: { halign: 'right' }, // 5순위 근교
                    19: { halign: 'right' }, // 부X외조부
                },
                headStyles: { fillColor: [22, 160, 133], halign: 'center', valign: 'middle', textColor: [255, 255, 255], lineColor: [0, 0, 0], lineWidth: 0.2 },
                alternateRowStyles: { fillColor: [245, 245, 245] },
                didParseCell: function (data) {
                    const inbreedingIndices = [5, 8, 11, 14, 17];
                    if (data.section === 'body' && inbreedingIndices.includes(data.column.index)) {
                        const value = parseFloat(data.cell.raw);
                        if (!isNaN(value) && value >= criticalInbreeding) {
                            data.cell.styles.textColor = [211, 47, 47]; // 근교 text색상 #d32f2f
                            data.cell.styles.fillColor = [177, 177, 177]; // 근교 배경색 #b1b1b1ff
                            data.cell.styles.fontStyle = 'bold';        // 근교 bold
                            data.row.cells[data.column.index - 2].styles.textColor = [211, 47, 47]; // 순위컬럼 text색상 #d32f2f
                            data.row.cells[data.column.index - 2].styles.fillColor = [177, 177, 177]; // 순위컬럼 배경색 #b1b1b1ff
                            data.row.cells[data.column.index - 1].styles.textColor = [211, 47, 47]; // 지수컬럼 text색상 #d32f2f
                            data.row.cells[data.column.index - 1].styles.fillColor = [177, 177, 177]; // 지수컬럼 배경색 #b1b1b1ff
                        }
                    }
                }
            });

            // 개량요망부위 추가
            let currentY = pdf.lastAutoTable.finalY + 10;

            // 페이지 공간 확인 (필요시 새 페이지 추가)
            if (currentY > pdf.internal.pageSize.height - 40) {
                pdf.addPage();
                currentY = 20;
            }

            pdf.setFontSize(10);
            pdf.setFont('NanumGothic', 'bold');
            pdf.text('개량요망부위', 14, currentY);

            currentY += 7;
            pdf.setFontSize(9);
            pdf.setFont('NanumGothic', 'normal');

            const improvementItems = [
                '01 엉덩이기울기', '02 엉덩이너비', '03 허리강건성', '04 유방깊이',
                '05 유방질', '06 정중제인대', '07 앞유방붙음성', '08 앞유두위치',
                '09 뒷유방높이', '10 뒷유방너비', '11 뒷유두위치', '12 뒷유두길이',
                '13 발굽기울기', '14 뒤꿈치깊이', '15 뼈질', '16 옆에서 본 뒷다리',
                '17 뒤에서 본 뒷다리', '18 보행성(2차)', '19 키', '20 전구높이',
                '21 가슴너비', '22 체심', '23 예각성', '24 BCS'
            ];

            // 12열 그리드로 출력 (2줄)
            const pageWidth = pdf.internal.pageSize.width;
            const marginLeft = 14;
            const marginRight = 14;
            const totalWidth = pageWidth - marginLeft - marginRight;
            const colWidth = totalWidth / 12;
            const startX = marginLeft;
            let x = startX;

            pdf.setFontSize(6);
            improvementItems.forEach((item, index) => {
                pdf.text(item + ',', x, currentY);
                if ((index + 1) % 12 === 0) { // 12개마다 줄바꿈
                    x = startX;
                    currentY += 6;
                } else {
                    x += colWidth;
                }
            });

            // 3. 두 번째 테이블 (정액 정보) 그리기
            pdf.addPage();
            pdf.setFontSize(14);
            pdf.text('정액 정보', 14, 15);

            autoTable(pdf, {
                head: [semenColumns.map(c => c.title)],
                body: semenInfoResults.map(row => semenColumns.map(c => row[c.data])),
                startY: 20,
                margin: { left: 14, right: 14 },
                styles: { font: 'NanumGothic', fontSize: 8, cellPadding: 1.5 },
                headStyles: { fillColor: [41, 128, 185], halign: 'center' },
                alternateRowStyles: { fillColor: [245, 245, 245] },
            });

            // 4. 푸터 정보 그리기 (ResultBottom 내용)
            pdf.setFontSize(12);
            pdf.text('공급업체 주소 및 연락처', 14, pdf.lastAutoTable.finalY + 15);
            pdf.setFontSize(9);
            const bottomData = (supplierInfo && supplierInfo.length > 0)
                ? supplierInfo.map(info => [info.icmp_no || '-', info.icmp_cname || '-'])
                : [['-', '-']];
            autoTable(pdf, {
                startY: pdf.lastAutoTable.finalY + 18,
                head: [['공급업체번호', '업체명']],
                body: bottomData,
                theme: 'plain',
                styles: { font: 'NanumGothic', fontSize: 9 },
                headStyles: { fontStyle: 'bold', textColor: [75, 85, 99] },
                columnStyles: {
                    0: { halign: 'right', cellWidth: 40 },
                    1: { halign: 'left' },
                },
                didParseCell: (data) => {
                    if (data.section === 'head' && data.column.index === 0) {
                        data.cell.styles.halign = 'right';
                    }
                },
            });

            // 5. PDF 저장
            const today = new Date();
            const yyyymmdd = today.getFullYear().toString()
                + String(today.getMonth() + 1).padStart(2, '0')
                + String(today.getDate()).padStart(2, '0');
            pdf.save(`${yyyymmdd}_${farmName || '농장'}_계획교배결과.pdf`);
        } catch (error) {
            console.error("PDF 생성 중 오류 발생:", error);
            setDialog({ isOpen: true, title: "PDF 생성 실패", message: "PDF 파일을 생성하는 중 오류가 발생했습니다.", onClose: () => setDialog({ isOpen: false }) });
        } finally {
            setIsGeneratingPdf(false);
        }
    };

    useEffect(() => {
        const executeMatingPlan = async () => {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append('member_id', selectedFarm.id);
                formData.append('prod_rate', filters.prodRatio);
                formData.append('inbreed_coeff', filters.inbreedingCoefficient);
                formData.append('nation', filters.country);
                formData.append('semenlist', planState.selectedSires.map(s => s.jm_jmregno).join(','));
                formData.append('cowlist', planState.selectedCows.map(c => c.cow_regno).join(','));
                formData.append('mtype1', user?.mtype1);
                // API 호출로 실제 교배 계획 결과를 가져옵니다.
                const response = await axios.post('/api/mating', formData);
                setMatingResults(response.data.list1 || []);
                setSemenInfoResults(response.data.list2 || []);
                // list3 전체 배열을 공급업체번호(icmp_no) 오름차순으로 정렬하여 저장합니다.
                if (response.data.list3) {
                    const list = Array.isArray(response.data.list3) ? response.data.list3 : [response.data.list3];
                    const sorted = [...list].sort((a, b) => {
                        const aNo = (a.icmp_no || '').toString();
                        const bNo = (b.icmp_no || '').toString();
                        return aNo.localeCompare(bNo, undefined, { numeric: true });
                    });
                    setSupplierInfo(sorted);
                }
            } catch (error) {
                console.error("계획교배 실행 실패:", error);
                setDialog({
                    isOpen: true,
                    title: "실행 오류",
                    message: "계획교배 결과를 가져오는 중 오류가 발생했습니다.",
                    onClose: () => setDialog({ isOpen: false })
                });
                setMatingResults([]);
                setSemenInfoResults([]);
                setSupplierInfo([]);
            } finally {
                setLoading(false);
            }
        };

        if (planState.selectedSires.length > 0 && planState.selectedCows.length > 0) {
            executeMatingPlan();
        } else {
            setLoading(false);
        }
    }, [planState.selectedSires, planState.selectedCows, selectedFarm.id, setDialog]);

    const columns = useMemo(() => {
        const criticalInbreeding = 12.5;

        const renderInbreeding = (data, type) => {
            if (type === 'display') {
                const value = parseFloat(data);
                if (!isNaN(value) && value >= criticalInbreeding) {
                    return `<span class="high-inbreeding high-inbreeding-bg">${data}</span>`;
                }
            }
            return data;
        };

        const shadowCell = (key) => (td, cellData, rowData) => {
            const value = parseFloat(rowData[key]);
            if (!isNaN(value) && value >= criticalInbreeding) {
                td.style.backgroundColor = '#b1b1b1ff';
                td.style.color = '#d32f2f';
                td.style.fontWeight = 'bold';
            }
        };

        const renderHighInbreeding = (key) => (data, type, row) => {
            if (type === 'display') {
                const value = parseFloat(row[key]);
                if (!isNaN(value) && value >= criticalInbreeding) {
                    // indices_N의 경우 이미 index-container 구조가 있을 수 있으므로 처리
                    if (typeof data === 'string' && data.includes('index-container')) {
                        return data.replace('index-container', 'index-container high-inbreeding high-inbreeding-bg');
                    }
                    return `<span class="high-inbreeding high-inbreeding-bg">${data}</span>`;
                }
            }
            return data;
        };

        const renderIndex = (num) => (data, type, row) => {
            if (type === 'display') {
                const inbreedingValue = parseFloat(row[`icoef_${num}`]);
                const isHigh = !isNaN(inbreedingValue) && inbreedingValue >= criticalInbreeding;
                const baseKey = `indices_${num}`;
                const extraKey = `sub_idx_${num}`;
                const content = row[baseKey] || '';
                const extraContent = row[extraKey] || '';

                return `
                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; min-height: 42px;">
                        <span>${content}</span>
                        <span class="index-sep"> / </span>
                        <span>${extraContent}</span>
                    </div>
                `;
            }
            return data;
        };

        const renderRank = (num) => (data, type, row) => {
            if (type === 'display') {
                const inbreedingValue = parseFloat(row[`icoef_${num}`]);
                const isHigh = !isNaN(inbreedingValue) && inbreedingValue >= criticalInbreeding;
                const shortName = row[`h_short_${num}`] || '';

                return `
                    <div style="display: flex; flex-direction: column; align-items: flex-end; justify-content: center; gap: 2px; min-height: 42px; width: 100%; text-align: right;">
                        <span style="font-weight: ${isHigh ? 'bold' : 'normal'};">${data || ''}</span>
                        <span style="font-size: 0.75rem; color: ${isHigh ? '#d32f2f' : '#6b7280'};">${shortName}</span>
                    </div>
                `;
            }
            return data;
        };

        return [
            { title: '관리번호', data: 'mgmt_no' },
            { title: '단축명호', data: 'cow_sname' },
            { title: '등록번호', data: 'cow_regno' },
            { title: '1순위', data: 'place_1', render: renderRank(1), createdCell: shadowCell('icoef_1') },
            {
                title: '지수',
                data: 'indices_1',
                render: renderIndex(1),
                createdCell: shadowCell('icoef_1')
            },
            { title: '근교', data: 'icoef_1', render: renderInbreeding, createdCell: shadowCell('icoef_1') },
            { title: '2순위', data: 'place_2', render: renderRank(2), createdCell: shadowCell('icoef_2') },
            {
                title: '지수',
                data: 'indices_2',
                render: renderIndex(2),
                createdCell: shadowCell('icoef_2')
            },
            { title: '근교', data: 'icoef_2', render: renderInbreeding, createdCell: shadowCell('icoef_2') },
            { title: '3순위', data: 'place_3', render: renderRank(3), createdCell: shadowCell('icoef_3') },
            {
                title: '지수',
                data: 'indices_3',
                render: renderIndex(3),
                createdCell: shadowCell('icoef_3')
            },
            { title: '근교', data: 'icoef_3', render: renderInbreeding, createdCell: shadowCell('icoef_3') },
            { title: '4순위', data: 'place_4', render: renderRank(4), createdCell: shadowCell('icoef_4') },
            {
                title: '지수',
                data: 'indices_4',
                render: renderIndex(4),
                createdCell: shadowCell('icoef_4')
            },
            { title: '근교', data: 'icoef_4', render: renderInbreeding, createdCell: shadowCell('icoef_4') },
            { title: '5순위', data: 'place_5', render: renderRank(5), createdCell: shadowCell('icoef_5') },
            {
                title: '지수',
                data: 'indices_5',
                render: renderIndex(5),
                createdCell: shadowCell('icoef_5')
            },
            { title: '근교', data: 'icoef_5', render: renderInbreeding, createdCell: shadowCell('icoef_5') },
            { title: '개량부위', data: 'req_improve' },
            { title: '부X외조부 (한글)', data: 'father_nm' },
        ];
    }, [filters.country, filters.inbreedingCoefficient]);

    const semenColumns = useMemo(() => {
        const country = planState.filters?.country;
        // 1. 공통 컬럼 - 앞부분
        const baseColumns = [
            { title: '씨수소번호', data: 'jm_semencode' },
            { title: '명호(한)', data: 'h_short' },
            { title: '명호(영)', data: 'e_short' },
            { title: 'A2', data: 'beta_casein' },
        ];

        // 3. 공통 컬럼 - 뒷부분
        const tailColumns = [
            { title: '부X외조부', data: 'siremgsmggs' },
            { title: '공급업체', data: 'makercode' },
        ];

        // 2. 국가별 헤더 및 구성 정의
        let dynamicPart = [];

        if (country === '03') { // 캐나다
            dynamicPart = [
                { title: 'LPI', data: 'ocapa_tpi' },
                { title: 'Pro$', data: 'netmerit' },
                { title: 'Milk', data: 'pta_milk' },
                { title: 'Protein', data: 'pta_pro' },
                { title: 'Fat', data: 'pta_fat' },
                { title: 'Conformation', data: 'ptat' },
                { title: 'Mammary System', data: 'udc' },
                { title: 'Feet & Legs', data: 'flc' },
                { title: 'Herd Life', data: 'pl' },
                { title: 'Calving Ability', data: 'dpr' },
                { title: 'Daughter Calving Ability', data: 'nansan' },
                { title: 'Milking Speed', data: 'miking_speed' },
            ];
        } else if (country === '02' || country === '04') { // 미국, 기타
            dynamicPart = [
                { title: 'TPI', data: 'ocapa_tpi' },
                { title: 'NM$', data: 'netmerit' },
                { title: 'PTAM', data: 'pta_milk' },
                { title: 'PTAP', data: 'pta_pro' },
                { title: 'PTAF', data: 'pta_fat' },
                { title: 'PTAT', data: 'ptat' },
                { title: 'UDC', data: 'udc' },
                { title: 'FLC', data: 'flc' },
                { title: 'PL', data: 'pl' },
                { title: 'DPR', data: 'dpr' },
                { title: 'SCS', data: 'scs' },
                { title: 'Milking Speed', data: 'miking_speed' },
            ];
        } else { // 한국 (01) 및 기본값
            dynamicPart = [
                { title: 'KTPI', data: 'ocapa_tpi' },
                { title: 'MFP천원', data: 'netmerit' },
                { title: 'EBVM', data: 'pta_milk' },
                { title: 'EBVP', data: 'pta_pro' },
                { title: 'EBVF', data: 'pta_fat' },
                { title: 'PTAT', data: 'ptat' },
                { title: 'UDC', data: 'udc' },
                { title: 'FLC', data: 'flc' },
                { title: 'Herd Life', data: 'pl' },
                { title: 'SCS', data: 'scs' },
            ];
        }

        return [...baseColumns, ...dynamicPart, ...tailColumns];
    }, []);

    useEffect(() => {
        if (matingResults.length > 0) {
            const options = {
                columns: columns,
                responsive: { details: { type: 'inline' } },
                paging: true,
                lengthChange: false,
                pageLength: 20,
                searching: false,
                ordering: true,
                data: matingResults,
                language: {
                    emptyTable: "계획교배 결과가 없습니다.",
                    paginate: { first: "처음", last: "마지막", next: "다음", previous: "이전" },
                    info: "_TOTAL_건 중 _START_에서 _END_까지 표시",
                    infoEmpty: "0건",
                },
                columnDefs: [
                    { responsivePriority: 1, targets: 0, className: 'dt-body-left' },
                    { responsivePriority: 2, targets: 1 },
                    { targets: 2, className: 'dt-body-right' },
                    { targets: [3, 6, 9, 12, 15], className: 'dt-body-right' }, // 순위 컬럼 우측 정렬
                    { targets: [4, 7, 10, 13, 16], className: 'dt-body-center' }, // 지수 컬럼 중앙 정렬
                    { targets: [5, 8, 11, 14, 17], className: 'dt-body-right' }, // 근교 컬럼 우측 정렬
                    { targets: 19, className: 'dt-body-right' },
                ],
                drawCallback: function () {
                    this.api().responsive.recalc();
                }
            };
            dtApi.current = $(tableRef.current).DataTable(options);
        }

        return () => {
            if (dtApi.current) {
                dtApi.current.destroy();
                dtApi.current = null;
            }
        };
    }, [matingResults, columns]);

    useEffect(() => {
        if (semenInfoResults.length > 0) {
            const options = {
                columns: semenColumns,
                responsive: { details: { type: 'inline' } },
                paging: false,
                searching: false,
                ordering: true,
                data: semenInfoResults,
                info: false,
                language: {
                    emptyTable: "정액 정보가 없습니다.",
                },
                columnDefs: [
                    { responsivePriority: 1, targets: 1, className: 'dt-body-right' },//우측 정렬
                ],
                drawCallback: function () {
                    this.api().responsive.recalc();
                }
            };
            semenDtApi.current = $(semenTableRef.current).DataTable(options);
        }
        return () => {
            if (semenDtApi.current) {
                semenDtApi.current.destroy();
                semenDtApi.current = null;
            }
        };
    }, [semenInfoResults, semenColumns]);

    return (
        <div ref={resultRef}>
            <ResultHeader
                onPdfExport={handlePdfExport}
                isGenerating={isGeneratingPdf}
                filters={filters}
                isFarmOwner={isFarmOwner}
                managementValues={getManagementValues()}
                nationValues={getNationValues()}
            />

            {loading && (
                <div className="loading-overlay">
                    <div className="loading-message">계획교배 실행 중...</div>
                </div>
            )}

            <div className="card" style={{ marginBottom: '1.5rem' }}>
                <h4 style={{ fontWeight: '600', marginBottom: '1rem' }}>계획교배 결과</h4>
                <div className="table-container">
                    <table ref={tableRef} className="display nowrap" style={{ width: '100%' }}></table>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e5e7eb', paddingBottom: '0.75rem', marginBottom: '1rem' }}>
                    <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#374151', margin: 0 }}>
                        개량요망부위
                    </h3>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '0.5rem 0.75rem', fontSize: '0.875rem' }}>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>01 엉덩이기울기,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>02 엉덩이너비,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>03 허리강건성,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>04 유방깊이,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>05 유방질,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>06 정중제인대,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>07 앞유방붙음성,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>08 앞유두위치,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>09 뒷유방높이,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>10 뒷유방너비,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>11 뒷유두위치,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>12 뒷유두길이,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>13 발굽기울기,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>14 뒤꿈치깊이,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>15 뼈질,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>16 옆에서 본 뒷다리,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>17 뒤에서 본 뒷다리,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>18 보행성(2차),</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>19 키,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>20 전구높이,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>21 가슴너비,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>22체심,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>23 예각성,</span>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <span style={{ color: '#1f2937' }}>24 BCS</span>
                    </div>
                </div>
            </div>

            <div className="card" style={{ marginBottom: '1.5rem' }}>
                <h4 style={{ fontWeight: '600', marginBottom: '1rem' }}>정액 정보</h4>
                <div className="table-container">
                    <table ref={semenTableRef} className="display nowrap" style={{ width: '100%' }}></table>
                </div>
            </div>

            <ResultBottom supplierInfo={supplierInfo} />
        </div>
    );
};

export default MatingPlanResult;
